import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';
import history from '../utils/history';

export const getUsers = theSessionId => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch(getUsersRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/security/users',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getUsersSuccess(res.data));
      })
      .catch(err => {
        dispatch(getUsersFailure(err));
      });
  };
};

export const getUser = id => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/security/users/' + id,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getUserSuccess(res.data));
      })
      .catch(err => {
        dispatch(getUserFailure(err));
      });
  };
};

export const addUser = user => {
  const sessionId = getSessionId();
  delete user['id'];
  return dispatch => {
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/security/users',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: user
    })
      .then(res => {
        dispatch(addUserSuccess(res.data));
        history.push('/users');
      })
      .catch(err => {
        dispatch(saveUserFailure(user, err));
      });
  };
};

export const saveUserInLocalState = user => {
  return {
    type: Constants.USERS_SAVE_LOCAL_SUCCESS,
    payload: user
  };
};

export const updateUser = (id, user, route = '/users') => {
  const sessionId = getSessionId();
  delete user['id'];
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/security/users/' + id,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: user
    })
      .then(res => {
        dispatch(saveUserSuccess(res.data));
        dispatch(getUser(id));
        history.push(route);
      })
      .catch(err => {
        dispatch(saveUserFailure(user, err));
      });
  };
};

export const deleteUser = roleId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/security/users/' + roleId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(deleteUserSuccess(res.data));
      })
      .catch(err => {
        dispatch(deleteUserFailure(err));
      });
  };
};

const addUserSuccess = data => {
  return {
    type: Constants.USERS_ADD_SUCCESS,
    payload: data
  };
};

const saveUserSuccess = data => {
  return {
    type: Constants.USERS_SAVE_SUCCESS,
    payload: data
  };
};

const saveUserFailure = (user, err) => {
  const message = getPayloadFromError(err);
  const payload = { user, message };
  return {
    type: Constants.USERS_SAVE_FAILURE,
    payload
  };
};

const deleteUserSuccess = data => {
  return {
    type: Constants.USERS_DELETE_SUCCESS,
    payload: data
  };
};

const deleteUserFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.USERS_DELETE_FAILURE,
    payload
  };
};

export const clearUsersError = () => {
  return {
    type: Constants.USERS_CLEAR_ERROR
  };
};

const getUsersRequest = () => {
  return {
    type: Constants.USERS_GET_REQUEST
  };
};

const getUsersSuccess = data => {
  return {
    type: Constants.USERS_GET_SUCCESS,
    payload: data
  };
};

const getUsersFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.USERS_GET_FAILURE,
    payload
  };
};

const getUserSuccess = data => {
  return {
    type: Constants.USER_GET_SUCCESS,
    payload: data
  };
};

const getUserFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.USER_GET_FAILURE,
    payload
  };
};
